<script>

import config from '../../common/genericPanelConf';
import GenericTreeTable from '@/components/generic/GenericTreeTable.vue';
import CommonService from '@/services/common'

export default {
    props: ['category', 'name'],
    components: {
        GenericTreeTable
    },
    data(){
        return{
            configuration: null,
            cloneAggregationDialog: {
                visible: false,
                body: {
                    tipologiaAggregazioneFromID: null,
                    nome: '',
                    descrizione: ''
                }
            }
        }
    },
    created(){
        this.configuration = config.getConfiguration(this.name);
        if(this.configuration){
            this.$store.dispatch('security/setNavbarTitle', this.configuration.title);
        }
    },
    mounted(){
        
    },
    methods: {
        onAdd(){
            let uri = `/${this.category}/${this.name}/0`;
            this.$router.push(uri);
        },
        openCloneAggregationClick(id){
            this.cloneAggregationDialog.body = {
                tipologiaAggregazioneFromID: id,
                nome: '',
                descrizione: ''
            }
            this.cloneAggregationDialog.visible = true;
        },
        cloneAggregation(){
            let cloneApi = `stocchino-plan-registry/aggregation-type-clone`;
            let body = {...this.cloneAggregationDialog.body}
            CommonService.createItem(cloneApi, body, response => {
                console.log(response)
            })
        }
    },
    computed: {
        conf(){
            return config;
        }
    }
}
</script>



<template>
    <Dialog v-model:visible="cloneAggregationDialog.visible" :style="{width: '50vw'}" :modal="true" :header="$t('btn.clone')">
            <div class="grid">
                <div class="col-12 lg:col-3">
                    <label>{{$t('StocchinoPlanAggregationType.nome')}}</label>
                    <InputText 
                        v-model="cloneAggregationDialog.body.nome" 
                        :class="{'w-full': true}" /> 
                </div>
                <div class="col-12 lg:col-3">
                    <label>{{$t('StocchinoPlanAggregationType.descrizione')}}</label>
                    <InputText 
                        v-model="cloneAggregationDialog.body.descrizione" 
                        :class="{'w-full': true}" /> 
                </div>
            </div>
            <template #footer>
                <Button :label="$t('btn.cancel')" text severity="secondary" @click="cloneAggregationDialog.visible = false" autofocus />
                <Button :label="$t('btn.add')" outlined severity="secondary" @click="cloneAggregation" autofocus icon="pi pi-plus" />
            </template>
        </Dialog>
    <div class="" style="height: 80vh;">
        <GenericTreeTable :configuration="configuration" :category="category" :name="name" @on-open-clone-aggregation-click="openCloneAggregationClick"/>
    </div>
</template>